import {
  Flex,
  Input,
  Typography,
  Empty,
  Skeleton,
  Button,
  Tag,
  Checkbox,
} from "antd";
import styles from "./right-drawer.module.css";
import CustomSelect from "@/components/inputs/CustomSelect";
import SearchIcon from "@/icons/Search";
import ChevronDownIcon from "@/icons/ChevronDownIcon";
import ChevronUpIcon from "@/icons/ChevronUpIcon";

const SearchPanel = ({
  className = "",
  searchValue = "",
  searchInSelectedDefinitions = true,
  onSearchInSelectedDefinitionsChange,
  onSearch,
  onApplySearch,
  searchResults = [],
  onSelectObject,
  isLoading,
  definitionValue = [],
  onDefinitionChange,
  definitionsOptions = [],
  isDefinitionRequired = false,
  isClickResult = false,
  onCancelMapClick,
  showResultsToggle = false,
  areResultsVisible = true,
  onToggleResults,
  hideControls = false,
  hideResults = false,
}) => {
  const shouldShowResults = !showResultsToggle || areResultsVisible;
  const resultsCount = searchResults?.length || 0;
  const hasSearch = Boolean(
    typeof searchValue === "string" ? searchValue.trim() : searchValue,
  );
  const selectedDefinitionsCount = Array.isArray(definitionValue)
    ? definitionValue.length
    : 0;

  const renderDefinitionTag = ({ label, closable, onClose }) => {
    const isLastSelectedDefinition = selectedDefinitionsCount <= 1;

    return (
      <Tag
        closable={closable && !isLastSelectedDefinition}
        onClose={onClose}
        style={{ marginInlineEnd: 4, fontSize: 12 }}
      >
        {label}
      </Tag>
    );
  };

  return (
    <Flex vertical className={`${styles.search_panel} ${className}`} gap={16}>
      {!hideControls && (
        <>
          <Input.Search
            placeholder="Поиск объектов"
            value={searchValue || ""}
            onChange={(e) => onSearch(e.target.value || null)}
            onSearch={(value) => onSearch(value || null)}
            allowClear
            enterButton={<Button icon={<SearchIcon />} />}
          />

          <Checkbox
            checked={searchInSelectedDefinitions}
            disabled={!hasSearch}
            onChange={(event) =>
              onSearchInSelectedDefinitionsChange?.(event.target.checked)
            }
          >
            Среди выбранных типов
          </Checkbox>

          <CustomSelect
            mode="multiple"
            placeholder="Тип ресурса"
            options={definitionsOptions}
            fieldNames={{
              label: "name",
              value: "uuid",
              key: "uuid",
            }}
            allowClear
            value={definitionValue}
            onChange={(value) => onDefinitionChange(value)}
            maxTagCount={1}
            status={isDefinitionRequired ? "error" : undefined}
            tagRender={renderDefinitionTag}
          />

          {isDefinitionRequired && (
            <Typography.Text type="danger" style={{ fontSize: 12 }}>
              Выберите хотя бы один тип ресурса
            </Typography.Text>
          )}

          {showResultsToggle && (
            <Button
              type="link"
              icon={areResultsVisible ? <ChevronUpIcon /> : <ChevronDownIcon />}
              onClick={onToggleResults}
              className={styles.search_panel__toggle}
            >
              {areResultsVisible
                ? `Свернуть (${resultsCount})`
                : `Результаты поиска (${resultsCount})`}
            </Button>
          )}
        </>
      )}

      {!hideResults && isLoading && <Skeleton active size="large" />}

      {!hideResults && !isLoading && shouldShowResults && searchValue && searchResults?.length === 0 && (
        <Empty description="Ничего не найдено" />
      )}

      {!hideResults &&
        !isLoading &&
        shouldShowResults &&
        searchResults?.length > 0 &&
        (searchValue || definitionValue?.length > 0 || isClickResult) && (
          <>
            {!isClickResult && (
              <Typography.Link
                onClick={() => onApplySearch(searchResults)}
                className={styles.search_panel__link}
              >
                Показать все на карте
              </Typography.Link>
            )}

            {isClickResult && searchValue && (
              <Typography.Link
                onClick={onCancelMapClick}
                className={styles.search_panel__link}
              >
                К результатам поиска
              </Typography.Link>
            )}

            <Flex vertical className={styles.search_panel__list}>
              {searchResults.map((item) => (
                <div
                  key={item.object.uuid}
                  onClick={() => {
                    onSelectObject(item);
                    onCancelMapClick?.();
                  }}
                  className={styles.search_panel__list_item}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#fafafa")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                >
                  <Flex gap={4} align="center" justify="space-between" wrap>
                    <span>{item.object.name}</span>
                    <Tag color={item.definition.color}>{item.definition.name}</Tag>
                  </Flex>
                </div>
              ))}
            </Flex>
          </>
        )}
    </Flex>
  );
};

export default SearchPanel;
